module.exports = __webpack_public_path__ + "img/digital_card_bohinj_header_summer.fd2db060.png";